import {callAPI} from '@/store/utils';

const FYGR_COMPANY = 'FYGR_COMPANY';

export default {
  namespaced: true,
  state: {
    managedTrial: [],
    needPlan: '',
    subscription: {},
    showTrial: false,
    showTrialButton: false,
  },
  mutations: {
    removeFromManagedTrial(state, id) {
      const managed = [...state.managedTrial];
      const idx = managed.findIndex((m) => m === id);
      managed.splice(idx, 1);
      state.managedTrial = [...managed];
    },
    setSubscriptionStatus(state, subscription) {
      state.subscription = subscription;
    },
    setNeedPlan(state, needPlan) {
      state.needPlan = needPlan;
    },
    setManagedTrial(state, managedTrial) {
      state.managedTrial = managedTrial;
    },
    setShowTrialValue(state, value) {
      if (value !== null && value !== undefined) {
        state.showTrial = value;
      } else {
        state.showTrial = !state.showTrial;
      }
    },
    setShowTrialButton(state, value) {
      if (value !== null && value !== undefined) {
        state.showTrialButton = value;
      } else {
        state.showTrialButton = !state.showTrialButton;
      }
    },
  },
  actions: {
    async actionGetSubscriptionForCompany({commit}, params) {
      const companyId = localStorage.getItem(FYGR_COMPANY);
      const res = await callAPI('POST', 'getSubscriptionForCompany', {
        ...params,
        companyId,
      });
      commit('setSubscriptionStatus', res.result || {});
      return res;
    },
    async actionGetTrialCpaChildren({commit}, params) {
      const res = await callAPI('POST', 'getTrialCpaChildren', {...params});
      if (!res.error) {
        commit('setManagedTrial', res.result);
      }
      return res;
    },
    actionRemoveFromManagedTrial({commit}, {id}) {
      commit('removeFromManagedTrial', id);
    },
    actionNeedPlan({commit}, value) {
      commit('setNeedPlan', value);
    },
    actionChangeShowTrial({commit}, value) {
      commit('setShowTrialValue', value);
      if (!value) {
        commit('setNeedPlan', '');
      }
    },
    actionChangeShowTrialButton({commit}, value) {
      commit('setShowTrialButton', value);
    },
  },
};
